import React from 'react';

export default function AboutUs() {
  return (
    <section className="min-h-screen flex flex-col">
      {/* Hero Section */}
      <div 
        className="h-[40vh] md:h-[50vh] bg-cover bg-center relative flex items-center justify-center" 
        style={{ backgroundImage: "url('/images/background_aboutus.jpg')" }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative text-center text-white px-4">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">About Us</h2>
          <p className="text-lg md:text-xl max-w-3xl mx-auto">
            We’re more than a service provider—we're your trusted technology partner, helping businesses unlock their full potential.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-grow container mx-auto px-6 py-12">
        {/* About Details */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <ContentBlock title="Our Story">
            <p>
              Whether it's Software Engineering, UI/UX Design, IT Consulting, or Business Strategy - we have experts for all your needs. With a commitment to innovation and high-quality solutions, we are a trusted partner for businesses worldwide.
            </p>
            <p>
              Our journey has been shaped by forward-thinkers who thrive on creating impactful solutions that help businesses grow.
            </p>
          </ContentBlock>
          
          <ContentBlock title="Our Mission">
            <p>
              Our mission is to help businesses scale and thrive through cutting-edge technology solutions. We’re dedicated to delivering excellence and transforming ideas into tangible results.
            </p>
            <p>
              We focus on understanding your unique challenges and goals to create customized solutions that drive efficiency and unlock growth potential.
            </p>
          </ContentBlock>
        </div>

        {/* Core Values */}
        <ContentBlock title="Our Core Values" className="mt-8">
          <ul className="list-disc list-inside space-y-2">
            <li><strong>Innovation:</strong> Pushing the boundaries of technology for better solutions.</li>
            <li><strong>Integrity:</strong> Transparent, honest, and ethical services at all times.</li>
            <li><strong>Excellence:</strong> Delivering high-quality results in every project.</li>
            <li><strong>Customer-Centricity:</strong> Putting your business needs first for long-term success.</li>
          </ul>
        </ContentBlock>

        {/* Call to Action */}
        <div className="mt-12 text-center">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">Let’s Build the Future Together</h3>
          <p className="text-lg text-gray-600 mb-6">
            Whether you're a startup or an established enterprise, we have the expertise and dedication to help you grow in the digital world. Let’s create something extraordinary together.
          </p>
          <button className="px-6 py-3 bg-slate-600 text-white font-bold rounded-lg hover:bg-slate-700 transition">Contact Us Now</button>
        </div>
      </div>
    </section>
  );
}

function ContentBlock({ title, children, className = "" }) {
  return (
    <div className={`p-6 md:p-8 rounded-lg shadow-lg bg-white bg-opacity-90 ${className}`}>
      <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">{title}
      <img
          src="/images/unterstrch.png"
          alt="Underline"
          className="relative left-1/8 transform -translate-x-1 bottom-6 w-1/5 
 opacity-80 z-10 transition-opacity duration-300 group-hover:opacity-0"
        />
      </h2>
      {children}
    </div>
  );
}
